import React from 'react';
import { createPortal } from 'react-dom';
import TreeViewItem from '../tree-view-item';
/* 
  TreeViewItemDragPreview renders the drag preview using createPortal.
  createPortal is necessary to escape any transform: translate3d() on parent elements,
  which would otherwise affect position: fixed positioning and cause the preview
  to appear misaligned from the cursor. By rendering at document.body level,
  the preview positions relative to the viewport (not transformed ancestors),
  ensuring accurate cursor-following behavior.
*/
const TreeViewItemDragPreview = ({ clientOffset, item, isDragging }) => {
  if (!isDragging || !item?.data || !clientOffset) {
    return null;
  }

  const { title, iconGlyph, customIconGlyph, iconType } = item.data;

  return createPortal(
    <div
      className="ws-ui-tree-view-item-drag-preview"
      style={{
        left: `${clientOffset.x - 10}px`,
        top: `${clientOffset.y - 10}px`,
      }}
    >
      <TreeViewItem
        isDragging
        title={title}
        iconGlyph={iconGlyph}
        customIconGlyph={customIconGlyph}
        iconType={iconType}
        draggable={false}
      />
    </div>,
    document.body
  );
};

export default TreeViewItemDragPreview;
